import { SharedModule } from '@/app/shared/shared.module';
import { Component, Input, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-csi-header',
  imports: [SharedModule],
  templateUrl: './csi-header.component.html',
  styleUrl: './csi-header.component.less',
})
export class CsiHeaderComponent {
  @Input() breadcrumbs: any[] = [];
  @Input() header: string;
  @Input() description: string;
  @Input() sortBtnLabel: string;
  @Input() sortMenus: MenuItem[] = [];

  @ViewChild('menu') menuPopup: any;

  constructor() {}

  onMenuClick(event: any, menu: MenuItem) {
    event.stopPropagation();
    event.preventDefault();
    menu.command(event);

    this.menuPopup.hide();
  }
}
